import { Discount } from "./Discount";
import { DiscountTarget, DiscountType } from "./RawCost";


export class ReturningClientDiscount extends Discount
{
    constructor()
    {
        super({
            Target: DiscountTarget.WholeBasket,
            Type: DiscountType.LimitedPercent,
            Name: "ponowne zakupy",
            Code: "returning-client",
            Value: 10,
            Limit: 500,
            IsVisible: true,
        });
    }
}
